import { cn } from 'utils/cn';

/**
 * The grey pill the header draws most of its actions as: the task and notification counters, the help
 * button and the profile menu's trigger. The left padding is tighter than the right because the
 * counters lead with an icon and end with their number. A counter is disabled until its data has
 * loaded, since its drawer would only show an empty list meanwhile.
 */
const StyledHeaderButton = ({ className, type = 'button', ...props }: React.ComponentProps<'button'>) => (
    <button
        type={type}
        className={cn(
            'bg-grey-100 hover:bg-grey-300 text-grey-700 flex w-fit cursor-pointer items-center justify-center gap-1 rounded-[8px] py-1.5 pr-2 pl-1 text-[13px] leading-none font-semibold transition-colors disabled:pointer-events-none',
            className
        )}
        {...props}
    />
);

/**
 * A header counter's number. The button is drawn before its count has loaded, and the slot keeps one
 * digit's width meanwhile, so the header row does not widen when the number lands.
 */
export const HeaderButtonCount = ({ count }: { count: number | undefined }) => (
    <span className="min-w-[1ch] text-center">{count}</span>
);

export default StyledHeaderButton;
